var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCcw04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.8747C19.1213 17.3292 20.5 14.8256 20.5 12.0001C20.5 7.30568 16.6944 3.5001 12 3.5001H11.5M12 20.5001C7.30558 20.5001 3.5 16.6945 3.5 12.0001C3.5 9.17456 4.87867 6.67103 7 5.1255M11 22.4001L13 20.4001L11 18.4001M13 5.6001L11 3.6001L13 1.6001",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCcw04);
export default __webpack_public_path__ + "static/media/refresh-ccw-04.569d220a8026c9d26efd636f531c8689.svg";
export { ForwardRef as ReactComponent };